// @flow

class MobileNumber {
  constructor(number: string, valid: boolean) {
    this.number = number;
    this.valid = valid;
  }
}

MobileNumber.prototype.validLength = '10';

MobileNumber.prototype.inputType = 'text';

MobileNumber.prototype.validRegex = 'onlynumber';

MobileNumber.prototype.validateMobileNumber = (mobileNumber: MobileNumber) =>
  mobileNumber &&
  mobileNumber.number &&
  mobileNumber.number.length === Number(MobileNumber.prototype.validLength);

export default MobileNumber;
